export default __webpack_public_path__ + "static/media/schedule-bg.1d93b947.jpg";